'use strict';

/**
 * @ngdoc directive
 * @name prepApp.directive:login
 * @description
 * # login
 */
angular.module('prepApp')
    .directive('login', function ($log, $document, Auth, BasicService) {
        return {
            restrict: 'A',
            templateUrl: 'views/directives/login.html',
            link: function (scope, elem) {
                scope.$watch('username', function () {
                    var loginError = $document[0].getElementById('loginErrorMsg');
                    loginError.hidden = true;
                });
                scope.$watch('password', function () {
                    var loginError = $document[0].getElementById('loginErrorMsg');
                    loginError.hidden = true;
                });

                var successCallback = function () {
                    scope.password = undefined;
                };

                var errorCallback = function (response) {
                    $log.log('ERROR', response);
                    var loginError = $document[0].getElementById('loginErrorMsg');
                    BasicService.cookies.remove('sessionid');
                    loginError.hidden = false;
                };

                elem.bind('submit', function () {
                    var userData = {
                        username: scope.username,
                        password: scope.password
                    };
                    Auth.login(userData).then(successCallback, errorCallback);
                });
            }
        };
    });
